import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SinistroService {
  private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getSinistros() {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/sinistro')
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getSinistro(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/sinistro/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getSinistrosByUsuario(usuario) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/sinistro/usuario/' + usuario)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaSinistro(data) {
		
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/sinistro', {
				veiculo_id: data.veiculo_id,
				profissional_id: data.profissional_id,
				sinistro_data: data.sinistro_data,
				sinistro_tipo: data.sinistro_tipo,
				sinistro_natureza: data.sinistro_natureza,
				sinistro_nf_servico: data.sinistro_nf_servico,
				sinistro_nf_peca: data.sinistro_nf_peca,
				sinistro_descricao: data.sinistro_descricao,
				sinistro_boat: data.sinistro_boat,
				sinistro_investigacao: data.sinistro_investigacao,
				sinistro_doc_veiculo: data.sinistro_doc_veiculo,
				sinistro_cnh: data.sinistro_cnh,
				sinistro_boat_nome: data.sinistro_boat_nome,
				sinistro_investigacao_nome: data.sinistro_investigacao_nome,
				sinistro_doc_veiculo_nome: data.sinistro_doc_veiculo_nome,
				sinistro_cnh_nome: data.sinistro_cnh_nome,
				sinistro_valor: data.sinistro_valor,
				pecas: data.pecas,
				servicos: data.servicos,
				sinistro_boat_arquivo: data.sinistro_boat_arquivo,
				sinistro_investigacao_arquivo: data.sinistro_investigacao_arquivo,
				sinistro_doc_veiculo_arquivo: data.sinistro_doc_veiculo_arquivo,
				sinistro_cnh_arquivo: data.sinistro_cnh_arquivo
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaSinistro(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/sinistro/' + data.sinistro_id, {
				veiculo_id: data.veiculo_id,
				profissional_id: data.profissional_id,
				sinistro_data: data.sinistro_data,
				sinistro_tipo: data.sinistro_tipo,
				sinistro_natureza: data.sinistro_natureza,
				sinistro_nf_servico: data.sinistro_nf_servico,
				sinistro_nf_peca: data.sinistro_nf_peca,
				sinistro_descricao: data.sinistro_descricao,
				sinistro_boat: data.sinistro_boat,
				sinistro_investigacao: data.sinistro_investigacao,
				sinistro_doc_veiculo: data.sinistro_doc_veiculo,
				sinistro_cnh: data.sinistro_cnh,
				sinistro_boat_nome: data.sinistro_boat_nome,
				sinistro_investigacao_nome: data.sinistro_investigacao_nome,
				sinistro_doc_veiculo_nome: data.sinistro_doc_veiculo_nome,
				sinistro_cnh_nome: data.sinistro_cnh_nome,
				sinistro_valor: data.sinistro_valor,
				pecas: data.pecas,
				servicos: data.servicos,
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaSinistro(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/sinistro/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getSinistroArquivo(id,col){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/sinistro/getArquivo/' + id + '/' + col)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}
}
